import React, { useState, useEffect } from "react";
import ConfigDB from "../../config";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  getVehicleCheckList,
  deleteVehicleCheckList,
} from "../../services/VehiclePartCheckServices";

const VehiclePartCheck = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const navigate = useNavigate();
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const location = useLocation();
  const RolePermission = Utils.getRecordForCurrentPath(location);
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [partList, setPartList] = useState([]);

  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    page: 1,
  });

  const [filterData, setFilterData] = useState({
    catalog_name: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    number_of_car_doors: "",
    individual: "",
    depends_body_car: "",
    is_master_part: "",
  });

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
      localStorage.removeItem("filterDataCatelog");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value); // Save search to localStorage
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1; // ReactPaginate starts from 0, so we add 1
      localStorage.setItem("lastVisitedPage", e.selected + 1); // Save the selected page to localStorage
    }

    localStorage.setItem("filterDataCatelog", JSON.stringify(paramsObj));

    setParams(paramsObj);
  };

  useEffect(() => {
    const savedFilterData = localStorage.getItem("filterDataCatelog");
    if (savedFilterData) {
      const parsedFilterData = JSON.parse(savedFilterData);
      setParams(parsedFilterData);
      setFilterData(parsedFilterData);
    }
  }, []);

  const fetchPartCheck = () => {
    let data = {
      ...params,
      page: params.page ?? 1,
    };
    return getVehicleCheckList(data)
      .then((response) => {
        setPartList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    fetchPartCheck();
  }, [params]);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deleteVehicleCheckList(data)
      .then((response) => {
        let datas = { ...params };
        fetchPartCheck(datas);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <>
        <div>
          {/* Your existing content goes here */}
          <section className="content-header">
            <div className="container-fluid ">
              <div className="row mb-2 px-2">
                <div className="col-sm-6">{/* <h1>Part Catalog</h1> */}</div>
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid container-custom-height-new">
              <div className="row">
                <div className="col-md-12">
                  <div className="card fuelCard">
                    <div className="card-header">
                      <div
                        className="card-title m-0 float-left"
                        style={{ width: "50%" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={params.search}
                          onChange={(e) => handleParams(e, "search")}
                          placeholder="Search"
                        />
                      </div>

                      <div className="card-title m-0 float-right d-flex">
                        <div className="card-title-row">
                          {RolePermission?.findIndex(
                            (e) =>
                              e.permission_name === "modify_vehicle_checklist"
                          ) > -1 && (
                            <button
                              type="button"
                              className="btn btn-icon-text mr-2"
                              onClick={() =>
                                navigate("/add-check-list-vehicles")
                              }
                            >
                              <i className="bi bi-plus-lg"></i>
                              <span className="ms-2">{t("Add")}</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="vehicleThBg table-responsive table-responsive-vehicle">
                        <table className="table table-bordered rounded-table table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "10%" }}>{t("name")}</th>

                              <th style={{ width: "10%" }}>
                                {t("is_default")}
                              </th>
                              <th style={{ width: "0%" }}>{t("action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partList?.map((item, index) => (
                              <tr key={item.id}>
                                <td>{item?.name}</td>
                                <td>
                                  {Number(item.is_default) === 1 ? "Yes" : "No"}
                                </td>
                                <td>
                                  <div className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive"
                                            );
                                          if (window.innerWidth <= 767) {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "auto !important";
                                              tableResponsive.style.overflowY =
                                                "auto !important";
                                            }
                                          } else {
                                            if (tableResponsive) {
                                              tableResponsive.style.overflowX =
                                                "inherit !important";
                                              tableResponsive.style.overflowY =
                                                "inherit !important";
                                            }
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        {/* Edit */}

                                        {RolePermission?.some(
                                          (e) =>
                                            e.permission_name ===
                                            "modify_vehicle_checklist"
                                        ) && (
                                          <Dropdown.Item
                                            className="d-flex"
                                            onClick={() =>
                                              navigate(
                                                `/update-check-list-vehicles/${item.id}`,
                                                { state: item }
                                              )
                                            }
                                          >
                                            <div className="edit-btn">
                                              <i className="bi bi-pencil"></i>
                                            </div>
                                            <span>{t("edit")}</span>
                                          </Dropdown.Item>
                                        )}

                                        {/* Delete */}

                                        {RolePermission?.some(
                                          (e) =>
                                            e.permission_name ===
                                            "delete_vehicle_checklist"
                                        ) && (
                                          <Dropdown.Item
                                            className="d-flex"
                                            onClick={(e) =>
                                              onDeleteModalOpen(e, item)
                                            }
                                          >
                                            <div className="trash-btn">
                                              <a
                                                href="#"
                                                className="delete-btn"
                                              >
                                                <i className="bi bi-trash3"></i>
                                              </a>
                                            </div>
                                            <span>{t("delete")}</span>
                                          </Dropdown.Item>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                            {partList && partList.length === 0 && (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  {t("no_record_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer clearfix">
              <div className="pagination pagination-sm m-0 float-right card-footer-part">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </section>
        </div>
        {/* )} */}

        <Modal isOpen={delModal}>
          <ModalHeader>{`Delete Vehicle Part Check`}</ModalHeader>
          <ModalBody>
            <p
              className={`mb-0`}
            >{`Are you sure you want to delete this Vehicle Part Check?`}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isDelButtonLoad}
              onClick={onDeleteModalClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>

            {!isDelButtonLoad && (
              <button
                type="button"
                className="btn btn-block bg-red"
                style={{ width: "100px" }}
                onClick={onDestroyPartType}
              >
                {t("delete")} <i className="bi bi-trash3"></i>
              </button>
            )}
            {isDelButtonLoad && (
              <button
                color="secondary"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </button>
            )}
          </ModalFooter>
        </Modal>
      </>
    </div>
  );
};

export default VehiclePartCheck;
